import { Box, Drawer, Typography } from '@mui/material';
import { FunctionComponent } from 'react';

import { BedroomsQuery } from '../../../../../apollo/__generated__/graphql';
import { BedroomForm } from '../BedroomForm/BedroomForm';
import { useEditBedroomDrawer } from './useEditBedroomDrawer';

interface EditBedroomDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  bedroom: BedroomsQuery['bedrooms'][0];
}

export const EditBedroomDrawer: FunctionComponent<EditBedroomDrawerProps> = ({
  isOpen,
  onClose,
  bedroom,
}) => {
  const { errors, onSubmit, register } = useEditBedroomDrawer(bedroom, onClose);

  return (
    <Drawer anchor="right" open={isOpen} onClose={onClose}>
      <Box sx={{ mt: 10, mx: 2 }}>
        <Typography variant="h4">Modifier une chambre</Typography>
        <BedroomForm
          errors={errors}
          register={register}
          onSubmit={onSubmit}
          submitButtonLabel="Modifier"
        />
      </Box>
    </Drawer>
  );
};
